var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { utilTime } from "../../utils/utilTime";
export var HOCProgressDelay = function () { return function (TickableComponent) {
    return /** @class */ (function (_super) {
        __extends(ProgressDelay, _super);
        function ProgressDelay(props) {
            var _this = _super.call(this, props) || this;
            _this.elapsedSeconds = 0;
            var _a = _this.props, duration = _a.duration, remainingTime = _a.remainingTime;
            if (duration != undefined) {
                _this.elapsedSeconds = duration - utilTime.secondsLeftTill(remainingTime);
            }
            return _this;
        }
        ProgressDelay.prototype.render = function () {
            return (React.createElement(TickableComponent, __assign({ delay: this.elapsedSeconds }, this.props, this.state)));
        };
        return ProgressDelay;
    }(React.Component));
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/button-with-progress/HOCProgressDelay.tsx
// module id = 2626
// module chunks = 3